export enum ApplicationType {
  Eservice = 0,
  Webform = 1,
}

export enum FormType {
  Intyg_om_forskrivningsratt = 1,
  Intyg_om_AT_tjanstgoring = 2,
  Intyg_om_kontaktlinsbehorighet = 3,
  Intyg_for_aktuell_legitimation = 4,
  Intyg_for_legitimation_inom_EU = 5,
  Artikel_33 = 6,
  Intyg_om_ej_reglerat_yrke = 99,
}

export enum ReCaptchaFormName {
  Intyg_om_forskrivningsratt = 'intyg_forskrivningsratt',
  Intyg_om_AT_tjanstgoring = 'intyg_at_tjanstgoring',
  Intyg_om_kontaktlinsbehorighet = '_intyg_kontaktlinsbehorighet',
  Intyg_for_aktuell_legitimation = 'intyg_aktuell_legitimation',
  Intyg_for_legitimation_inom_EU = 'intyg_legitimation_inom_eu',
  Artikel_33 = 'intyg_artikel_3_dot_3',
  Intyg_om_ej_reglerat_yrke = 'intyg_ej_reglerat_yrke',
}

export enum FieldName {
  YrkeId = 'yrkeId',
  SkickaTillFolkbokforing = 'skickaTillFolkbokforing',
  AntalSvenskaTillFolkbokforing = 'antalSvenskaTillFolkbokforing',
  AntalEngelskaTillFolkbokforing = 'antalEngelskaTillFolkbokforing',
  SkickaPdf = 'skickaPdf',
  SkickaPost = 'skickaPost',
  PdfSvenska = 'pdfSvenska',
  PdfEngelska = 'pdfEngelska',
  Epost = 'epost',
  ContentId = '__contentId',
  LanguageId = '__languageId',
  Adressrad1 = 'adressrad1',
  Adressrad2 = 'adressrad2',
  Adressrad3 = 'adressrad3',
  Adressrad4 = 'adressrad4',
  Adressrad5 = 'adressrad5',

  Personnummer = 'personnummer',
  Fornamnn = 'fornamn',
  Efternamn = 'efternamn',
  Gatuadress = 'gatuadress',
  Postnummer = 'postnummer',
  Postort = 'postort',
  Bekraftaepost = 'bekraftaepost',
  Examensar = 'examensar',
  Utbildningstid = 'utbildningstid',

  AntalSvenska = 'antalSvenska',
  AntalEngelska = 'antalEngelska',
  VillkorCheckbox = 'VillkorCheckbox',
}

export enum Section {
  ValjYrke = 'ValjYrke',
  YrkeMedAntal = 'YrkeMedAntal',
  Personuppgifter = 'Personuppgifter',
  PersonuppgifterEjRegleratYrke = 'PersonuppgifterEjRegleratYrke',
  TaEmotIntyget = 'TaEmotIntyget',
  SprakForIntyget = 'SprakForIntyget',
  Adressuppgifter = 'Adressuppgifter',
  Villkor = 'Villkor',
  Fileupload = 'Fileupload',
  FileuploadClient = 'FileuploadClient',
}
